/* tslint:disable */
/* eslint-disable */
/**
 * Bikeleasing Accounts
 * Consumers of the API must follow the tolerant reader pattern. Especially the consumer    * must ignore unknown properties   * expect enumerations to be extended at any time (this includes discriminators)      These changes are considered backwards compatible.   However, we will never do a backwards-incompatible change without creating a new API version:   * removal of required properties   * removal of a supported request parameter   * adding a new required request parameter or attributes   * renaming of an attribute      All responses contain a common header `X-Request-Id` which identifies the individual HTTP request. This ID should be included in any bug reports or support requests.  There is a per-client rate limit on the API. If the rate limit is exceeded (resulting in a \"429 Too Many Requests\" response), please slow down and retry  after a short delay.  The API strives to return status codes that align with user expectations. However, in some error cases, multiple status codes may seem appropriate, and  the expected status code might not be clear. Here are two important points to consider when dealing with error status codes: 1. The API first checks the user\'s permission to access a resource. Only if the user has permission, it attempts to retrieve the resource. As a consequence, a user will     see a `403 Access Denied` status when requesting non-existent single resources since the permission check fails first. 2. There are no permissions on collections, only on the resources contained within them. Therefore, the API never returns a `403 Access Denied` status because the user     lacks permission to access a collection. Instead, the API returns a list containing all resources the user has permission to access. If the user has no permission to any     resource in the collection, an empty list with a `200 OK` status code is returned.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import type { Address } from './address';
// May contain unused imports in some cases
// @ts-ignore
import type { MeCompanySettings } from './me-company-settings';

/**
 * Limited employee profile information exposed to the authenticated end user
 * @export
 * @interface MeEmployee
 */
export interface MeEmployee {
  /**
   *
   * @type {string}
   * @memberof MeEmployee
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MeEmployee
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof MeEmployee
   */
  salutation: string;
  /**
   *
   * @type {string}
   * @memberof MeEmployee
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof MeEmployee
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof MeEmployee
   */
  emailAddress: string;
  /**
   *
   * @type {Address}
   * @memberof MeEmployee
   */
  address: Address;
  /**
   * A phone number in the format +[country code][number] without any non-digits, e.g. +49171123123
   * @type {string}
   * @memberof MeEmployee
   */
  privatePhoneNumber?: string | null;
  /**
   * A phone number in the format +[country code][number] without any non-digits, e.g. +49171123123
   * @type {string}
   * @memberof MeEmployee
   */
  workPhoneNumber?: string | null;
  /**
   * A phone number in the format +[country code][number] without any non-digits, e.g. +49171123123
   * @type {string}
   * @memberof MeEmployee
   */
  mobilePhoneNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof MeEmployee
   */
  employeeNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof MeEmployee
   */
  costCenter?: string | null;
  /**
   * List of required actions that the employee must complete
   * @type {Array<string>}
   * @memberof MeEmployee
   */
  requiredActions: Array<MeEmployeeRequiredActionsEnum>;
  /**
   *
   * @type {MeCompanySettings}
   * @memberof MeEmployee
   */
  companySettings: MeCompanySettings;
}

export const MeEmployeeRequiredActionsEnum = {
  UpdateProfile: 'UpdateProfile',
} as const;

export type MeEmployeeRequiredActionsEnum = (typeof MeEmployeeRequiredActionsEnum)[keyof typeof MeEmployeeRequiredActionsEnum];
